import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  getListMoLine,
  getListProcesos,
  getUserTaller,
} from "../services/ConnectDataBase";
import { insertAdminMoLine } from "../services/api/operations/AdminMoLineApi";
import { notify } from "../services/ui/notify";
import { SCREEN_IDS } from "../components/FullComponent.js";
import { DEPARTAMENTS, typeConnect } from "../constants/Constants";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  BRAND_COLORS,
  TEXT_COLORS,
} from "../style/colors.js";
import AppButton from "../components/Common/ui/AppButton";
import AppTextField from "../components/Common/ui/AppTextField";

const initialInsertForm = {
  po: "",
  mo: "",
  usuario: "",
  team: "",
  tipo: "",
  fecha_ini: "",
  fecha_fin: "",
  cantidad_proceso: "",
};

const initialUpdateForm = {
  codigo: "",
  po: "",
  mo: "",
  usuario: "",
  team: "",
  tipo: "",
  fecha_ini: "",
  fecha_fin: "",
  cantidad_proceso: "",
};

const AdminQueryData = () => {
  const [usuariosList, setUsuariosList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [tiposList, setTiposList] = useState([]);

  const [insertForm, setInsertForm] = useState(initialInsertForm);
  const [updateForm, setUpdateForm] = useState(initialUpdateForm);

  const [insertDuration, setInsertDuration] = useState(0);
  const [updateDuration, setUpdateDuration] = useState(0);

  const [searchResults, setSearchResults] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordData, setSelectedRecordData] = useState(null);

  const [insertLoading, setInsertLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [insertFeedback, setInsertFeedback] = useState(null);

  useEffect(() => {
    loadUsers();
    loadProcessOptions();
  }, []);

  const computeDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      return 0;
    }
    return Math.max(0, Math.round((endDate - startDate) / 60000));
  };

  const normalizeDateTimeLocal = (value) => {
    if (!value) return "";
    const raw = typeof value === "object" && value?.date ? value.date : value;
    const date = new Date(raw);
    if (!Number.isNaN(date.getTime())) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    return String(raw).replace(" ", "T").slice(0, 16);
  };

  const formatDisplayDateTime = (value) => {
    if (!value) return "--";
    const raw = typeof value === "object" && value?.date ? value.date : value;
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return String(raw);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: BACKGROUND_COLORS.CARD,
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.88rem",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "0.92rem",
    },
  };

  const sectionCardSx = {
    borderRadius: 3,
    border: `1px solid ${BORDER_COLORS.SECONDARY}`,
    boxShadow: "none",
    backgroundColor: BACKGROUND_COLORS.CARD,
  };

  const loadUsers = async () => {
    try {
      const fullMo = await getUserTaller(
        "partsMovements",
        typeConnect[0],
        SCREEN_IDS.PARTS_MOVEMENTS
      );
      const list = Array.isArray(fullMo)
        ? fullMo
        : Object.entries(fullMo || {}).map(([key, value]) => ({
            key,
            ...value,
          }));

      const listaUsuariosConNombreDeTeam = list
        .map((usuario) => usuario?.name)
        .filter(Boolean);

      const listaTeams = [
        ...new Set(
          list
            .map(
              (usuario) =>
                DEPARTAMENTS[String(usuario?.cod_team)] || usuario?.cod_team
            )
            .filter(Boolean)
        ),
      ];

      setUsuariosList(listaUsuariosConNombreDeTeam);
      setTeamsList(listaTeams);
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
    }
  };

  const loadProcessOptions = async () => {
    try {
      const listProcessOption = await getListProcesos(
        "MultipleMOWork",
        0,
        SCREEN_IDS.MULTIPLE_WORK
      );
      const items = Array.isArray(listProcessOption)
        ? listProcessOption
        : Object.values(listProcessOption || {});
      setTiposList(items.map((item) => item?.descripcion).filter(Boolean));
    } catch (error) {
      console.error("Error al cargar procesos:", error);
    }
  };

  const getUniqueKey = (item) =>
    `${item.codigo}-${item.usuario}-${item.tipo}-${item.fecha_ini?.date || item.fecha_ini}`;

  const handleInsertChange = (event) => {
    const { name, value } = event.target;
    setInsertForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "fecha_ini" || name === "fecha_fin") {
        setInsertDuration(computeDuration(next.fecha_ini, next.fecha_fin));
      }
      return next;
    });
  };

  const handleUpdateChange = (event) => {
    const { name, value } = event.target;
    setUpdateForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "fecha_ini" || name === "fecha_fin") {
        setUpdateDuration(computeDuration(next.fecha_ini, next.fecha_fin));
      }
      return next;
    });
  };

  const resetInsertForm = () => {
    setInsertForm(initialInsertForm);
    setInsertDuration(0);
  };

  const resetUpdateForm = () => {
    setUpdateForm(initialUpdateForm);
    setUpdateDuration(0);
    setSelectedRecord(null);
    setSelectedRecordData(null);
  };

  const handleInsert = async () => {
    if (
      !insertForm.po ||
      !insertForm.mo ||
      !insertForm.usuario ||
      !insertForm.team ||
      !insertForm.tipo ||
      !insertForm.fecha_ini ||
      !insertForm.fecha_fin ||
      !insertForm.cantidad_proceso
    ) {
      notify.warn("Completa todos los campos obligatorios para insertar.");
      setInsertFeedback({
        type: "error",
        message: "Completa todos los campos obligatorios para insertar.",
      });
      return;
    }

    setInsertLoading(true);
    setInsertFeedback(null);

    try {
      const result = await insertAdminMoLine({
        po: insertForm.po,
        mo: insertForm.mo,
        usuario: insertForm.usuario,
        team: insertForm.team,
        tipo: insertForm.tipo,
        fecha_ini: insertForm.fecha_ini,
        fecha_fin: insertForm.fecha_fin,
        cantidad_proceso: Number(insertForm.cantidad_proceso),
        duracion: insertDuration,
      });

      if (result?.status === "ok") {
        notify.success(result?.message || "Registro insertado correctamente.");
        setInsertFeedback({
          type: "success",
          message: result?.message || "Registro insertado correctamente.",
        });
        resetInsertForm();
      } else {
        notify.error(result?.message || "No se pudo insertar el registro.");
        setInsertFeedback({
          type: "error",
          message: result?.message || "No se pudo insertar el registro.",
        });
      }
    } catch (error) {
      console.error("Error al insertar:", error);
      notify.error("Se produjo un error al insertar el registro.");
      setInsertFeedback({
        type: "error",
        message: "Se produjo un error al insertar el registro.",
      });
    } finally {
      setInsertLoading(false);
    }
  };

  const searchRecords = async () => {
    if (!updateForm.po || !updateForm.mo) {
      notify.warn("Por favor, ingrese PO y MO para buscar.");
      return;
    }

    setSearchLoading(true);
    try {
      const response = await getListMoLine(
        "AdminGetMoLine",
        0,
        SCREEN_IDS.GENERAL,
        updateForm.po,
        updateForm.mo
      );

      if (Array.isArray(response)) {
        setSearchResults(response);
      } else {
        setSearchResults([]);
        notify.info("No se encontraron registros o hubo un error en la búsqueda.");
      }
    } catch (error) {
      console.error("Error al buscar registros:", error);
      notify.error("Error en la búsqueda de registros.");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleRowClick = (item) => {
    const uniqueKey = getUniqueKey(item);
    const fechaInicio = normalizeDateTimeLocal(item.fecha_ini);
    const fechaFin = normalizeDateTimeLocal(item.fecha_fin);

    setSelectedRecord(uniqueKey);
    setSelectedRecordData(item);
    setUpdateForm({
      codigo: item.codigo || "",
      po: item.po?.toString() || "",
      mo: item.mo || "",
      usuario: item.usuario || "",
      team: item.team || "",
      tipo: item.tipo || "",
      fecha_ini: fechaInicio,
      fecha_fin: fechaFin,
      cantidad_proceso: item.cantidad_proceso || "",
    });
    setUpdateDuration(computeDuration(fechaInicio, fechaFin));
  };

  const handleUpdate = async () => {
    if (
      !updateForm.codigo ||
      !updateForm.po ||
      !updateForm.mo ||
      !updateForm.usuario ||
      !updateForm.team ||
      !updateForm.tipo ||
      !updateForm.fecha_ini ||
      !updateForm.fecha_fin ||
      !updateForm.cantidad_proceso
    ) {
      notify.warn("Complete todos los campos del formulario de actualización.");
      return;
    }

    console.log("Datos originales seleccionados:", selectedRecordData);
    console.log("Registro a actualizar:", {
      po: updateForm.po,
      mo: updateForm.mo,
      usuario: updateForm.usuario,
      team: updateForm.team,
      tipo: updateForm.tipo,
      fecha_ini: updateForm.fecha_ini,
      fecha_fin: updateForm.fecha_fin,
      duracion: updateDuration,
      cantidad_proceso: updateForm.cantidad_proceso,
      orig_codigo: selectedRecordData?.codigo,
      orig_usuario: selectedRecordData?.usuario,
      orig_fecha_ini:
        selectedRecordData?.fecha_ini?.date || selectedRecordData?.fecha_ini,
    });

    notify.info("La migración del endpoint de actualización todavía está pendiente.");
  };

  return (
    <Box
      sx={{
        p: 2,
        minHeight: "85vh",
        backgroundColor: BACKGROUND_COLORS.PRIMARY,
      }}
    >
      <Paper
        sx={{
          p: 2,
          borderRadius: 3,
          border: `1px solid ${BORDER_COLORS.PRIMARY}`,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.05)",
          backgroundColor: BACKGROUND_COLORS.CARD,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.4rem", md: "1.8rem" },
                fontWeight: 700,
                color: TEXT_COLORS.BRAND,
                mb: 0.5,
              }}
            >
              Administración de Datos en t_fabrica
            </Typography>
            <Typography sx={{ color: TEXT_COLORS.SECONDARY, fontSize: "0.92rem" }}>
              Primera fase: inserción conectada a la nueva API y rediseño visual de la pantalla.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <Chip
              label="Insert conectado"
              size="small"
              sx={{
                backgroundColor: "rgba(46,125,50,0.12)",
                color: "#2e7d32",
                fontWeight: 700,
              }}
            />
            <Chip
              label="Update pendiente"
              size="small"
              variant="outlined"
              sx={{ fontWeight: 700 }}
            />
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} lg={8}>
            <Card sx={sectionCardSx}>
              <CardContent sx={{ p: 2.25 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 1.5,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: TEXT_COLORS.BRAND }}>
                      Insertar Registro
                    </Typography>
                    <Typography sx={{ fontSize: "0.82rem", color: TEXT_COLORS.SECONDARY }}>
                      Inserta una nueva línea usando `AdminInsertMoLine`.
                    </Typography>
                  </Box>
                  <Chip label="Nueva API" size="small" color="primary" />
                </Box>

                {insertFeedback ? (
                  <Alert severity={insertFeedback.type} sx={{ mb: 1.5, borderRadius: 2 }}>
                    {insertFeedback.message}
                  </Alert>
                ) : null}

                <Grid container spacing={1.5}>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      label="PO"
                      name="po"
                      value={insertForm.po}
                      onChange={handleInsertChange}
                      placeholder="406064"
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      label="MO"
                      name="mo"
                      value={insertForm.mo}
                      onChange={handleInsertChange}
                      placeholder="406064-020"
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      select
                      label="Usuario"
                      name="usuario"
                      value={insertForm.usuario}
                      onChange={handleInsertChange}
                      sx={fieldSx}
                    >
                      {usuariosList.map((user) => (
                        <MenuItem key={user} value={user}>
                          {user}
                        </MenuItem>
                      ))}
                    </AppTextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      select
                      label="Team"
                      name="team"
                      value={insertForm.team}
                      onChange={handleInsertChange}
                      sx={fieldSx}
                    >
                      {teamsList.map((team) => (
                        <MenuItem key={team} value={team}>
                          {team}
                        </MenuItem>
                      ))}
                    </AppTextField>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <AppTextField
                      select
                      label="Tipo"
                      name="tipo"
                      value={insertForm.tipo}
                      onChange={handleInsertChange}
                      sx={fieldSx}
                    >
                      {tiposList.map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          {tipo}
                        </MenuItem>
                      ))}
                    </AppTextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      label="Fecha Inicio"
                      name="fecha_ini"
                      type="datetime-local"
                      value={insertForm.fecha_ini}
                      onChange={handleInsertChange}
                      InputLabelProps={{ shrink: true }}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      label="Fecha Fin"
                      name="fecha_fin"
                      type="datetime-local"
                      value={insertForm.fecha_fin}
                      onChange={handleInsertChange}
                      InputLabelProps={{ shrink: true }}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <AppTextField
                      label="Cantidad Proceso"
                      name="cantidad_proceso"
                      type="number"
                      value={insertForm.cantidad_proceso}
                      onChange={handleInsertChange}
                      placeholder="1"
                      sx={fieldSx}
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    mt: 1.5,
                    px: 1.25,
                    py: 1,
                    borderRadius: 2,
                    backgroundColor: BACKGROUND_COLORS.PRIMARY,
                    border: `1px solid ${BORDER_COLORS.PRIMARY}`,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography sx={{ fontSize: "0.85rem", color: TEXT_COLORS.SECONDARY }}>
                    Duración calculada: <strong>{insertDuration}</strong> minuto(s)
                  </Typography>
                  <Typography sx={{ fontSize: "0.78rem", color: TEXT_COLORS.SECONDARY }}>
                    Se envía también `duracion` al endpoint nuevo.
                  </Typography>
                </Box>

                <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                  <AppButton
                    variantType="secondary"
                    onClick={resetInsertForm}
                    sx={{ fontWeight: 700 }}
                  >
                    Limpiar
                  </AppButton>
                  <AppButton
                    onClick={handleInsert}
                    disabled={insertLoading}
                  >
                    {insertLoading ? "Insertando..." : "Insertar Registro"}
                  </AppButton>
                </Box>
              </CardContent>
            </Card>

            <Card sx={{ ...sectionCardSx, mt: 2 }}>
              <CardContent sx={{ p: 2.25 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 1.5,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: TEXT_COLORS.BRAND }}>
                      Actualizar Registro
                    </Typography>
                    <Typography sx={{ fontSize: "0.82rem", color: TEXT_COLORS.SECONDARY }}>
                      La búsqueda sigue funcionando, pero la actualización aún no está migrada a la nueva API.
                    </Typography>
                  </Box>
                  <Chip label="Siguiente fase" size="small" variant="outlined" />
                </Box>

                <Grid container spacing={1.5} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <AppTextField
                      label="PO"
                      name="po"
                      value={updateForm.po}
                      onChange={handleUpdateChange}
                      placeholder="406064"
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <AppTextField
                      label="MO"
                      name="mo"
                      value={updateForm.mo}
                      onChange={handleUpdateChange}
                      placeholder="406064-020"
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <AppButton
                      fullWidth
                      variantType="secondary"
                      onClick={searchRecords}
                      disabled={searchLoading}
                    >
                      {searchLoading ? "Buscando..." : "Buscar Registros"}
                    </AppButton>
                  </Grid>
                </Grid>

                <Box sx={{ mt: 1.5 }}>
                  {searchResults.length > 0 ? (
                    <TableContainer
                      component={Paper}
                      sx={{
                        maxHeight: 220,
                        borderRadius: 2,
                        border: `1px solid ${BORDER_COLORS.PRIMARY}`,
                        boxShadow: "none",
                      }}
                    >
                      <Table stickyHeader size="small">
                        <TableHead>
                          <TableRow>
                            {["Código", "Usuario", "Tipo", "Fecha Inicio", "Cantidad"].map((label) => (
                              <TableCell
                                key={label}
                                sx={{
                                  backgroundColor: BRAND_COLORS.PRIMARY,
                                  color: TEXT_COLORS.LIGHT,
                                  fontWeight: 700,
                                  fontSize: "0.75rem",
                                }}
                              >
                                {label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {searchResults.map((item) => {
                            const uniqueKey = getUniqueKey(item);
                            return (
                              <TableRow
                                key={uniqueKey}
                                hover
                                selected={uniqueKey === selectedRecord}
                                onClick={() => handleRowClick(item)}
                                sx={{ cursor: "pointer" }}
                              >
                                <TableCell>{item.codigo}</TableCell>
                                <TableCell>{item.usuario || "--"}</TableCell>
                                <TableCell>{item.tipo || "--"}</TableCell>
                                <TableCell>{formatDisplayDateTime(item.fecha_ini)}</TableCell>
                                <TableCell>{item.cantidad_proceso || "--"}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Box
                      sx={{
                        px: 2,
                        py: 3,
                        borderRadius: 2,
                        border: `1px dashed ${BORDER_COLORS.LIGHT}`,
                        textAlign: "center",
                        color: TEXT_COLORS.SECONDARY,
                        backgroundColor: BACKGROUND_COLORS.PRIMARY,
                      }}
                    >
                      No hay resultados para mostrar.
                    </Box>
                  )}
                </Box>

                {selectedRecord ? (
                  <Box
                    sx={{
                      mt: 2,
                      p: 1.5,
                      borderRadius: 2,
                      border: `1px solid ${BORDER_COLORS.PRIMARY}`,
                      backgroundColor: BACKGROUND_COLORS.PRIMARY,
                    }}
                  >
                    <Typography sx={{ mb: 1.25, fontSize: "0.88rem", fontWeight: 700, color: TEXT_COLORS.BRAND }}>
                      Editar línea seleccionada (Código: {updateForm.codigo})
                    </Typography>
                    <Grid container spacing={1.25}>
                      <Grid item xs={12} md={6}>
                        <AppTextField label="Usuario" name="usuario" value={updateForm.usuario} onChange={handleUpdateChange} sx={fieldSx} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <AppTextField label="Cantidad Proceso" name="cantidad_proceso" type="number" value={updateForm.cantidad_proceso} onChange={handleUpdateChange} sx={fieldSx} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <AppTextField label="Fecha Inicio" name="fecha_ini" type="datetime-local" value={updateForm.fecha_ini} onChange={handleUpdateChange} InputLabelProps={{ shrink: true }} sx={fieldSx} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <AppTextField label="Fecha Fin" name="fecha_fin" type="datetime-local" value={updateForm.fecha_fin} onChange={handleUpdateChange} InputLabelProps={{ shrink: true }} sx={fieldSx} />
                      </Grid>
                    </Grid>

                    <Box sx={{ mt: 1.25, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                      <Typography sx={{ fontSize: "0.82rem", color: TEXT_COLORS.SECONDARY }}>
                        Duración calculada: <strong>{updateDuration}</strong> minuto(s)
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <AppButton variantType="secondary" onClick={resetUpdateForm}>
                          Cancelar
                        </AppButton>
                        <AppButton onClick={handleUpdate}>
                          Actualizar Registro
                        </AppButton>
                      </Box>
                    </Box>
                  </Box>
                ) : null}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} lg={4}>
            <Card sx={sectionCardSx}>
              <CardContent sx={{ p: 2.25 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: TEXT_COLORS.BRAND }}>
                      Quitar Calidad
                    </Typography>
                    <Typography sx={{ fontSize: "0.82rem", color: TEXT_COLORS.SECONDARY }}>
                      Este bloque todavía no está desarrollado.
                    </Typography>
                  </Box>
                  <Chip label="Pendiente" size="small" variant="outlined" />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default AdminQueryData;
